import React, {Fragment} from 'react';
import {FranceActive} from "./FranceActive";
import {FranceActiveMap} from "./map";
import {Stats} from "./stats";
import {logMatomoEvent, groupBy, getDeptWithPrefix, getRegionWithPrefix} from "../utils/utils";
import {departementsRegion, getRegionLabel} from "../utils/geojson";
import {Enterprises} from "./Enterprises";
import {RegionSelect} from "./RegionSelect";
import {DepartmentSelect} from "./DepartmentSelect";



function regroupEnterprises(data) {
    const enterprises = groupBy(data, "numeroStructure");
    return Object.keys(enterprises).map(structureNumber => {
        const sameEnterprises = enterprises[structureNumber];
        const firstEnterprises = sameEnterprises[0]
        return {
            ...firstEnterprises,
            totalEtpApres: sameEnterprises.map(item => item.totalEtpApres).reduce((acc, currentValue) => acc + currentValue),
            totalEtpEnDifficulte: sameEnterprises.map(item => item.totalEtpEnDifficulte).reduce((acc, currentValue) => acc + currentValue),
            totalFinancement: sameEnterprises.map(item => item.totalFinancement).reduce((acc, currentValue) => acc + currentValue)
        }
    }).sort((a, b) => a.denominationSociale.localeCompare(b.denominationSociale))
}

export class ProductionMaif extends React.Component {
    constructor(props) {
        super(props);
        this.clickOnRegion = this.clickOnRegion.bind(this)
        this.handleRegionFilterChange = this.handleRegionFilterChange.bind(this)
        this.handleDepartmentFilterChange = this.handleDepartmentFilterChange.bind(this)
        this.getDepartmentGeoJson = this.getDepartmentGeoJson.bind(this)
        this.setDepartmentValue = this.setDepartmentValue.bind(this)
        this.clickOnDepartment = this.clickOnDepartment.bind(this)
        this.applyFilters = this.applyFilters.bind(this)

        this._statsTitleRef = React.createRef();

        if (this.props.codeRegionSelected && this.props.labelRegionSelected && this.props.departmentsForRegion) {
            const departmentsList = this.props.departmentsForRegion.features ? this.props.departmentsForRegion.features.map(department => {return {...department.properties}}).sort((a, b) => a.code - b.code) : [{...this.props.departmentsForRegion.properties}]
            const departmentSelected = departmentsList.length === 1 ? { id: departmentsList[0].code, name: departmentsList[0].nom } : undefined
            this.state = {
                regionSelected: {
                    id: this.props.codeRegionSelected,
                    name: this.props.labelRegionSelected,
                    departments: this.props.departmentsForRegion
                },
                departmentSelected,
                departmentsList,
                showRegion: true,
                data: this.applyFilters(this.props.codeRegionSelected, departmentSelected ? departmentSelected.id : undefined)
            }
        } else {
            this.state = {
                showRegion: false,
                regionSelected: undefined,
                departmentSelected: undefined,
                data: props.data
            }
        }
    }

    applyFilters(regionId, department) {
        const filter = {
            region: getRegionLabel(regionId),
            codeDepartement: department
        }

        return this.props.data.filter(enterprise => {
            for (let key in filter) {
                const filterValue = filter[key]
                if (filterValue && filterValue !== '') {
                    const valueToCompare = enterprise[key]
                    if (valueToCompare !== filterValue) {
                        return false;
                    }
                }
            }
            return true;
        });
    }

    clickOnDepartment(idDept, name) {
        const currentSelectedDepartment = this.state.departmentSelected ? this.state.departmentSelected.id : undefined;
        if (idDept === currentSelectedDepartment) {
            this.setDepartmentValue(undefined, undefined);
        } else {
            logMatomoEvent('entreprises-soutenues', 'clic-departement', name);
            this.setDepartmentValue(`${idDept}`, name)
        }
    }

    clickOnRegion(idRegion, regionName) {
        const currentSelectedRegion = this.state.regionSelected ? this.state.regionSelected.id : undefined;
        if (idRegion === currentSelectedRegion) {
            this.setState({
                regionSelected: undefined,
                showRegion: false,
                departmentsList: undefined,
                departmentSelected: undefined,
                data: this.applyFilters(undefined, undefined)
            }, () => { this._statsTitleRef.current.focus(); })
        } else {
            logMatomoEvent('entreprises-soutenues', 'clic-region', regionName);
            const departments = departementsRegion(idRegion);
            const departmentsList = departments.features ? departments.features.map(department => {return {...department.properties}}).sort((a, b) => a.code - b.code) : [{...departments.properties}]
            const departmentSelected = departmentsList.length === 1 ? { id: departmentsList[0].code, name: departmentsList[0].nom } : undefined
            this.setState({
                regionSelected: {
                    id: idRegion,
                    name: regionName,
                    departments
                },
                departmentSelected,
                departmentsList,
                showRegion: true,
                data: this.applyFilters(idRegion, departmentSelected ? departmentSelected.id : undefined)
            }, () => { this._statsTitleRef.current.focus(); })
        }
    }

    handleRegionFilterChange(event) {
        const valueChunks = event.target.value.split("#");
        if (valueChunks.length > 1) {
            this.clickOnRegion(valueChunks[0], valueChunks[1])
        } else {
            const currentSelectedRegion = this.state.regionSelected ? this.state.regionSelected.id : undefined;
            this.clickOnRegion(currentSelectedRegion);
        }
    }

    handleDepartmentFilterChange(event) {
        const valueChunks = event.target.value.split("#");
        if (valueChunks.length > 1) {
            this.setDepartmentValue(valueChunks[0], valueChunks[1])
        } else {
            this.setDepartmentValue(undefined);
        }
    }

    setDepartmentValue(departmentSelectedId, departmentSelectedName) {
        const data = this.applyFilters(this.state.regionSelected ? this.state.regionSelected.id : undefined, departmentSelectedId);
        const departmentSelected = (departmentSelectedId && departmentSelectedName) ? {id: departmentSelectedId, name: departmentSelectedName} : undefined;
        this.setState({
            departmentSelected,
            data
        }, () => { this._statsTitleRef.current.focus(); })
    }

    getDepartmentGeoJson() {
        let features = []
        if (this.state.regionSelected && this.state.regionSelected.departments && this.state.departmentSelected) {
            if (this.state.regionSelected.departments.features) {
                features = this.state.regionSelected.departments.features.filter(feature => `${feature.properties.code}` === this.state.departmentSelected.id)
            } else {
                features = [this.state.regionSelected.departments];
            }
        }
        return {
            type:"FeatureCollection",
            features
        }
    }

    render() {
        const enterprises = regroupEnterprises(this.state.data);
        const locationWithPrefix = this.state.departmentSelected
            ? getDeptWithPrefix(this.state.departmentSelected)
            : this.state.regionSelected
                ? getRegionWithPrefix(this.state.regionSelected)
                : 'En France';
        return (
            <div className="main__block__content main__block__content__production">
                <section className="banner__production-maif">
                    <div id="production-maif">
                        <div className={"production-maif-container"}>
                            <div className={"production-data-container"}>
                                {this.state.regionSelected && (
                                    <button type="button" className={"back-region link-highlight"} onClick={() => this.clickOnRegion(this.state.regionSelected.id)} aria-label="Retour à la carte de France">Retour</button>
                                )}
                                <div className={"production-maps-stats-container"}>
                                    <div className={"production-maps-container"}>
                                        <div className="france-active-container">
                                            {!this.state.regionSelected && <Fragment>
                                                <a href="#general-selector-region" className="sr-only sr-only-focusable">
                                                    Version accessible de la carte - Sélectionner une région
                                                </a>
                                                <FranceActive prefixId={"entreprises-financees"} {...this.props} regionSelected={this.state.regionSelected} clickOnRegion={this.clickOnRegion} initialState={this.state.showRegion === false} handleSelection={false}/>
                                            </Fragment>}
                                            {this.state.regionSelected && (
                                                <div className={`region-layer${this.state.showRegion ? '' : ' unvisible'}`}>
                                                    <Fragment>
                                                        <a href="#general-selector-department" className="sr-only sr-only-focusable">
                                                            Version accessible de la carte - Sélectionner un département
                                                        </a>
                                                        <FranceActiveMap idOnArea={true} areaType={"entreprises-financees-departement"} highlightArea={this.getDepartmentGeoJson()} clickOnRegion={this.state.departmentsList.length === 1 ? () => {} : this.clickOnDepartment} id={"region"} center={[0.0, 0.0]} zoom={13} geoJson={this.state.regionSelected.departments} fitGeoJsonBounds={true} />
                                                        <button type="button" className={"back-region link-highlight"} onClick={() => this.clickOnRegion(this.state.regionSelected.id)} aria-label="Retour à la carte de France">Retour</button>
                                                    </Fragment>
                                                </div>
                                            )}
                                            <div className="stats__selector">
                                                <Stats data={this.state.data} title={locationWithPrefix} ref={this._statsTitleRef}/>
                                                {this.state.regionSelected && this.state.departmentsList.length > 1 && (<DepartmentSelect departments={this.state.departmentsList} departmentSelected={this.state.departmentSelected} clickOnDept={this.clickOnDepartment} />)}
                                                {!this.state.regionSelected && <RegionSelect {...this.props} clickOnRegion={this.clickOnRegion} show={this.state.showRegion === false} />}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.state.regionSelected && this.state.data.length > 0 && (
                                    <Enterprises enterprises={enterprises} location={locationWithPrefix}/>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}